export default {"src":"/_next/static/media/clock-red.27a41e87.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};